// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"ff98051e","287":"8f53be0b","696":"2bda39df","850":"08d39db9","936":"b3f3b8f8"}[chunkId] + ".js";
};